import { createActions } from 'redux-actions';
import ActionFactory from './ActionFactory';
import {
  createAlert,
  createWarningAlert,
} from './ActionCreators';
import {
  TEAM,
  GET_TEAM_MEMBERS,
  DELETE_MEMBER,
  SUBSCRIBE,
  GET_PENDING_SUBSCRIPTIONS,
  APPROVE_SUBSCRIPTION,
  DECLINE_SUBSCRIPTION,
  GET_PAYMENT_HISTORY,
} from '../constants/ActionTypes';
import TeamAPIConnector from '../api/TeamAPIConnectors';
import i18n from '../config/i18n';

const plainActions = createActions(
  ...Object.values(ActionFactory(GET_TEAM_MEMBERS)),
  ...Object.values(ActionFactory(DELETE_MEMBER)),
  ...Object.values(ActionFactory(SUBSCRIBE)),
  ...Object.values(ActionFactory(GET_PENDING_SUBSCRIPTIONS)),
  ...Object.values(ActionFactory(APPROVE_SUBSCRIPTION)),
  ...Object.values(ActionFactory(DECLINE_SUBSCRIPTION)),
  ...Object.values(ActionFactory(GET_PAYMENT_HISTORY)),
  { prefix: TEAM },
);

const thunkActions = {
  getTeamMembers: () => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getTeamMembersRequest());
        const result = await TeamAPIConnector.getTeamMembers();
        dispatch(plainActions.getTeamMembersSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.getTeamMembersFailure());
        dispatch(createWarningAlert(i18n.t('fetchMemberMsg_fail')));
      }
      return false;
    }
  ),
  deleteMember: (teamId, memberId) => (
    async (dispatch) => {
      try {
        dispatch(plainActions.deleteMemberRequest());
        await TeamAPIConnector.deleteMember(teamId, memberId);
        dispatch(plainActions.deleteMemberSuccess());
        return true;
      } catch (err) {
        dispatch(plainActions.deleteMemberFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  subscribe: planKey => (
    async (dispatch) => {
      try {
        dispatch(plainActions.subscribeRequest());
        await TeamAPIConnector.subscribe(planKey);
        dispatch(plainActions.subscribeSuccess());
        return true;
      } catch (err) {
        dispatch(plainActions.subscribeFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  getPendingSubscriptions: () => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getPendingSubscriptionsRequest());
        const result = await TeamAPIConnector.getPendingSubscriptions();
        dispatch(plainActions.getPendingSubscriptionsSuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.getPendingSubscriptionsFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  approveSubscription: id => (
    async (dispatch) => {
      try {
        dispatch(plainActions.approveSubscriptionRequest());
        await TeamAPIConnector.approveSubscription(id);
        dispatch(plainActions.approveSubscriptionSuccess());
        await dispatch(thunkActions.getPendingSubscriptions());
        return true;
      } catch (err) {
        dispatch(plainActions.approveSubscriptionFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  declineSubscription: id => (
    async (dispatch) => {
      try {
        dispatch(plainActions.declineSubscriptionRequest());
        await TeamAPIConnector.declineSubscription(id);
        dispatch(plainActions.declineSubscriptionSuccess());
        await dispatch(thunkActions.getPendingSubscriptions());
        return true;
      } catch (err) {
        dispatch(plainActions.declineSubscriptionFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
  getPaymentHistory: teamId => (
    async (dispatch) => {
      try {
        dispatch(plainActions.getPaymentHistoryRequest());
        const result = await TeamAPIConnector.getPaymentHistory(teamId);
        dispatch(plainActions.getPaymentHistorySuccess(result));
        return true;
      } catch (err) {
        dispatch(plainActions.getPaymentHistoryFailure());
        dispatch(createAlert(err));
      }
      return false;
    }
  ),
};

export default {
  ...plainActions,
  ...thunkActions,
};



// WEBPACK FOOTER //
// ./src/actions/TeamActionCreators.js